import "./OurProducts.scss";

import ArrowIcon from "../../assets/icons/arrow.svg";

import AuracleImg1 from "../../assets/images/auracle-img-1.png";
import AuracleImg2 from "../../assets/images/auracle-img-2.png";

import AgentsImg1 from "../../assets/images//agents-img-1.png";
import AgentsImg2 from "../../assets/images//agents-img-2.png";
import AgentsImg3 from "../../assets/images//agents-img-3.png";

import GridImg from "../../assets/images/Grid.svg";
import SparkleImg from "../../assets/images/sparkle.svg";

export default function OurProducts() {
	return (
		<>
			<div className="our-products">
				<div className="decoration our-products-light-1"/>
				<div className="decoration our-products-light-2"/>
				<img className="decoration our-products-grid-bg" src={GridImg} alt="Grid" />
				<img className="decoration our-products-sparkle-1" src={SparkleImg} alt="Sparkle" />
				<img className="decoration our-products-sparkle-2" src={SparkleImg} alt="Sparkle" />


				<div className="our-products-content-wrapper content-wrapper-lg">
					<h3 className="our-products-small-title">Our Values</h3>
					<h2 className="our-products-title">
						Our Products And Services
					</h2>
					<p className="our-products-desc">
						Join us on our journey as we continue to innovate and
						expand our AI capabilities, with upcoming features and
						enhancements aimed at enriching your experience
					</p>

					<div className="product-cards">
						<div className="product-card auracle">
							{/* background */}
							<div className="gradient-bg"></div>
							<div className="noise-bg"></div>

							<h4 className="product-card-title">
								Auracle
								<img
									src={ArrowIcon}
									alt="Arrow Icon"
									className="product-card-arrow"
								/>
							</h4>

							<ul className="product-card-texts">
								<li className="product-card-text">
									<h5 className="product-card-text-title">
										Technical Analysis
									</h5>
									<p className="product-card-text-desc">
										Provides in-depth technical analysis to
										support informed trading decisions
									</p>
								</li>

								<li className="product-card-text">
									<h5 className="product-card-text-title">
										Insights and Market Analysis
									</h5>
									<p className="product-card-text-desc">
										Delivers comprehensive market insights
										and analyses to identify trends and
										opportunities
									</p>
								</li>

								<li className="product-card-text">
									<h5 className="product-card-text-title">
										Aur API
									</h5>
									<p className="product-card-text-desc">
										Offers a robust API for seamless
										integration of our AI-driven insights
										into your platforms
									</p>
								</li>
							</ul>

							<img
								src={AuracleImg1}
								alt="Auracle"
								className="product-card-img auracle-img-1"
							/>
							<img
								src={AuracleImg2}
								alt="Auracle"
								className="product-card-img auracle-img-2"
							/>
						</div>

						<div className="product-card agents">
							{/* background */}
							<div className="gradient-bg"></div>
							<div className="noise-bg"></div>
							
							<h4 className="product-card-title">
								Agents
								<img
									src={ArrowIcon}
									alt="Arrow Icon"
									className="product-card-arrow"
								/>
							</h4>

							<ul className="product-card-texts">
								<li className="product-card-text">
									<h5 className="product-card-text-title">
										AurTrader
									</h5>
									<p className="product-card-text-desc">
										An AI-powered trading assistant designed
										to enhance your trading strategies and
										execution
									</p>
								</li>
							</ul>

							<img
								src={AgentsImg1}
								alt="Agents"
								className="product-card-img agents-img-1"
							/>
							<img
								src={AgentsImg2}
								alt="Agents"
								className="product-card-img agents-img-2"
							/>
							<img
								src={AgentsImg3}
								alt="Agents"
								className="product-card-img agents-img-3"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
